{
  "title": "Аккаунт",
  "registerTitle": "Регистрация",
  "subtitle": "Входите через email, Google, телефон или Telegram - любой способ открывает один и тот же аккаунт и кошелёк.",
  "email": "Email",
  "password": "Пароль",
  "showPassword": "Показать",
  "hidePassword": "Скрыть",
  "acceptTerms": "Я принимаю условия использования",
  "registerCta": "Создать аккаунт",
  "haveAccount": "Уже есть аккаунт?",
  "needAccount": "Нужен аккаунт?",
  "telegramHint": "Автовход Telegram Mini App включён (initData проверяется на сервере).",
  "unavailable": "Аутентификация ещё не активна",
  "telegramSoon": "Вход через Telegram скоро",
  "webSoon": "Веб-вход скоро",
  "googleDisabled": "Вход Google отключён, пока не настроен OAuth",
  "googleReady": "Продолжить с Google",
  "smsDisabled": "Вход по SMS отключён, пока не настроен провайдер",
  "smsReady": "Продолжить с телефоном",
  "orEmail": "Email",
  "registerShort": "Регистрация",
  "loginTitle": "Войти",
  "tabEmail": "Почта",
  "tabPhone": "Телефон",
  "emailPlaceholder": "E-mail",
  "phoneUnavailableTitle": "Вход по телефону пока недоступен",
  "phoneUnavailableBody": "SMS-сервис не подключён. Продолжите с почтой и паролем.",
  "phonePlaceholder": "50 123 45 67",
  "phoneInvalidAz": "Введите 9-значный мобильный номер Азербайджана (например, 50 123 45 67).",
  "casinoBonusInactive": "Кампания ещё не активна",
  "socialMethods": "Социальный вход",
  "orContinue": "или",
  "continueWithTelegram": "Продолжить с Telegram",
  "casinoBonus": "Бонус казино",
  "noRegistrationBonus": "Сейчас нет бонуса, который можно выбрать при регистрации.",
  "promoToggle": "Добавить промокод",
  "promoPlaceholder": "Промокод",
  "promoHint": "Код не применяется при регистрации. Его можно ввести позже на странице бонусов.",
  "acceptTermsPrefix": "Я прочитал(а) и принимаю ",
  "acceptTermsLink": "правила использования",
  "acceptTermsSuffix": ".",
  "acceptTermsRequired": "Для регистрации нужно принять правила.",
  "termsMissingNote": "Черновик правил на странице /qaydalar. Для публикации нужно отдельное разрешение. Отметьте поле для регистрации.",
  "registerSubmit": "Зарегистрироваться",
  "loginSubmit": "Войти",
  "socialSoon": "Вход через Google и Telegram в браузере пока не активен.",
  "haveAccountPrompt": "Уже есть аккаунт?",
  "haveAccountAction": "Войти",
  "needAccountPrompt": "Нужен аккаунт?",
  "needAccountAction": "Регистрация",
  "resetPassword": "Сбросить пароль",
  "closeDialog": "Закрыть",
  "forgotLink": "Забыли пароль?",
  "forgotTitle": "Сброс пароля",
  "forgotIntro": "Введите email аккаунта. Если он зарегистрирован, мы отправим ссылку для сброса.",
  "forgotCta": "Отправить ссылку",
  "forgotSent": "Если аккаунт с таким email существует, ссылка для сброса уже в пути. Проверьте входящие и папку «Спам».",
  "sendAgain": "Отправить ещё раз",
  "emailDeliveryOff": "Отправка писем на этом сервере пока не настроена, письмо не придёт.",
  "backToLogin": "Вернуться ко входу",
  "resetTitle": "Новый пароль",
  "newPassword": "Новый пароль",
  "confirmPassword": "Повторите пароль",
  "passwordsDontMatch": "Пароли не совпадают",
  "passwordRules": "Не менее 8 символов: буквы вместе с цифрами или символами.",
  "resetCta": "Сохранить пароль",
  "resetDone": "Пароль изменён. Все сеансы завершены - войдите с новым паролем.",
  "linkInvalid": "Ссылка недействительна, устарела или уже использована.",
  "requestNewLink": "Запросить новую ссылку",
  "checking": "Проверяем...",
  "verifyTitle": "Подтверждение email",
  "verifyIntro": "Нажмите кнопку, чтобы подтвердить адрес электронной почты.",
  "verifyCta": "Подтвердить email",
  "verifyDone": "Email подтверждён. Спасибо!",
  "verifyResendHint": "Новое письмо можно запросить на странице «Безопасность».",
  "securityTitle": "Безопасность аккаунта",
  "emailVerified": "Подтверждён",
  "emailNotVerified": "Не подтверждён",
  "resendVerification": "Отправить письмо ещё раз",
  "verificationSent": "Письмо с подтверждением отправлено.",
  "verificationSentAfterRegister": "Аккаунт создан. Мы отправили ссылку для подтверждения на ваш email.",
  "phoneTitle": "Вход по телефону",
  "phoneLinkTitle": "Добавить номер телефона",
  "phoneLabel": "Номер телефона",
  "phoneHint": "Номера Азербайджана можно вводить как 050 123 45 67. Для других стран начните с +.",
  "sendCode": "Отправить код",
  "codeLabel": "Код из SMS",
  "codeSentTo": "Мы отправили 6-значный код на {{phone}}.",
  "verifyCode": "Подтвердить",
  "resendCode": "Отправить код ещё раз",
  "resendIn": "Повторить через {{seconds}} с",
  "changeNumber": "Изменить номер",
  "phoneLinked": "Номер телефона добавлен.",
  "googleWorking": "Входим через Google...",
  "telegramWorking": "Входим через Telegram...",
  "telegramCancelled": "Вход через Telegram отменён.",
  "googleLinked": "Аккаунт Google привязан.",
  "googleCancelled": "Вход через Google отменён.",
  "signInToLink": "Войдите в свой аккаунт",
  "telegramWidgetUnavailable": "Вход через Telegram на сайте станет доступен после настройки домена бота. Внутри Telegram Mini App выполняет вход автоматически.",
  "telegramLinked": "Telegram привязан.",
  "signInRequired": "Войдите, чтобы управлять безопасностью аккаунта.",
  "loginMethods": "Способы входа",
  "methodPassword": "Email и пароль",
  "methodGoogle": "Google",
  "methodPhone": "Телефон (SMS)",
  "methodTelegram": "Telegram",
  "linked": "Привязан",
  "notLinked": "Не привязан",
  "link": "Привязать",
  "unlink": "Отвязать",
  "unlinked": "Способ входа удалён.",
  "lastMethodHint": "Единственный способ входа удалить нельзя.",
  "unavailableProvider": "Не настроено",
  "changePasswordTitle": "Сменить пароль",
  "setPasswordTitle": "Задать пароль",
  "currentPassword": "Текущий пароль",
  "savePassword": "Сохранить пароль",
  "passwordSaved": "Пароль сохранён. Остальные сеансы завершены.",
  "changeEmailTitle": "Сменить email",
  "newEmail": "Новый email",
  "saveEmail": "Сохранить email",
  "emailSaved": "Email обновлён. Подтвердите новый адрес из письма.",
  "reauthTitle": "Подтвердите, что это вы",
  "reauthIntro": "В целях безопасности введите пароль, чтобы продолжить.",
  "reauthPasswordless": "В целях безопасности войдите заново, чтобы продолжить.",
  "reauthCta": "Продолжить",
  "mfaCode": "Код из приложения-аутентификатора",
  "signInAgain": "Войти заново",
  "sessionsTitle": "Сеансы",
  "logout": "Выйти",
  "logoutAll": "Выйти на всех устройствах",
  "phoneNotSet": "Номер не указан",
  "errors": {
    "invalid_credentials": "Неверный email или пароль.",
    "too_many_requests": "Слишком много попыток. Подождите немного и попробуйте снова.",
    "email_taken": "Этот email уже зарегистрирован. Войдите в аккаунт.",
    "password_too_short": "Пароль слишком короткий (минимум 8 символов).",
    "password_too_long": "Пароль слишком длинный (максимум 128 символов).",
    "password_too_weak": "Слабый пароль. Сочетайте буквы с цифрами или символами.",
    "password_too_common": "Этот пароль слишком распространён. Выберите другой.",
    "password_contains_email": "Пароль не должен содержать имя из вашего email.",
    "invalid_or_expired_token": "Ссылка недействительна, устарела или уже использована.",
    "invalid_password": "Неверный пароль.",
    "invalid_email": "Введите корректный email.",
    "email_not_set": "У аккаунта нет email.",
    "reauth_required": "Подтвердите, что это вы, чтобы продолжить.",
    "password_not_set": "У аккаунта нет пароля. Войдите заново привязанным способом.",
    "email_required_for_password": "Сначала добавьте email, затем задайте пароль.",
    "email_delivery_unavailable": "Отправка писем пока не настроена.",
    "sms_disabled": "Вход по SMS пока недоступен.",
    "phone_auth_disabled": "Регистрация по телефону и вход по SMS временно отключены.",
    "sms_delivery_failed": "Не удалось отправить SMS. Попробуйте позже.",
    "invalid_phone": "Введите корректный номер телефона.",
    "resend_cooldown": "Подождите, прежде чем запрашивать новый код.",
    "otp_invalid": "Неверный или устаревший код.",
    "otp_expired": "Срок действия кода истёк. Запросите новый.",
    "otp_attempts_exceeded": "Слишком много неверных кодов. Запросите новый код.",
    "phone_in_use": "Этот номер принадлежит другому аккаунту.",
    "phone_signin_conflict_retry": "Попробуйте ещё раз.",
    "google_oauth_disabled": "Вход через Google пока недоступен.",
    "telegram_oidc_disabled": "Вход через Telegram на сайте пока недоступен.",
    "google_account_exists_link_required": "Аккаунт с этим email Google уже существует. Войдите в него, затем привяжите Google на странице «Безопасность».",
    "google_linked_to_other_account": "Этот аккаунт Google привязан к другому аккаунту VBB PLAY.",
    "google_other_account_linked": "Уже привязан другой аккаунт Google. Сначала отвяжите его.",
    "google_signin_conflict_retry": "Попробуйте ещё раз.",
    "invalid_state": "Попытка входа устарела или начата в другом браузере. Попробуйте снова.",
    "state_expired": "Попытка входа устарела. Попробуйте снова.",
    "nonce_mismatch": "Не удалось проверить вход через Google. Попробуйте снова.",
    "invalid_id_token": "Не удалось проверить вход через Google. Попробуйте снова.",
    "token_exchange_failed": "Google не подтвердил вход. Попробуйте снова.",
    "signing_key_unavailable": "Google временно недоступен. Попробуйте снова.",
    "link_session_mismatch": "Войдите в тот же аккаунт, в котором начали привязку.",
    "telegram_already_linked": "Этот Telegram привязан к другому аккаунту VBB PLAY.",
    "telegram_other_account_linked": "Уже привязан другой Telegram. Сначала отвяжите его.",
    "telegram_payload_required": "Telegram не передал данные для входа.",
    "auth_data_replayed": "Этот вход через Telegram уже использован. Войдите снова.",
    "auth_data_expired": "Вход через Telegram устарел. Попробуйте снова.",
    "invalid_hash": "Не удалось проверить вход через Telegram.",
    "last_login_method": "Единственный способ входа удалить нельзя.",
    "account_suspended": "Аккаунт заблокирован. Обратитесь в поддержку.",
    "admin_email_change_disabled": "Email администратора может изменить только оператор.",
    "mfa_required": "Введите код из приложения-аутентификатора."
  }
}
